import { render, staticRenderFns } from "./MedicinesCheckList.vue?vue&type=template&id=c674605e"
import script from "./MedicinesCheckList.js?vue&type=script&lang=js&external"
export * from "./MedicinesCheckList.js?vue&type=script&lang=js&external"
import style0 from "./MedicinesCheckList.vue?vue&type=style&index=0&id=c674605e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports